export enum TcsmFeatures {
	Compensation = 'Compensation',
	Employment = 'Employment',
	Relationships = 'Relationships',
	Institution = 'Institution',
	EmployeeSearch = 'EmployeeSearch',
	InstitutionSearch = 'InstitutionSearch',
	DioceseSearch = 'DioceseSearch',
	GroupSearch = 'GroupSearch',
	GroupsLanding = 'GroupsLanding',
	GroupAdminAdd = 'GroupAdminAdd',
	PeopleLanding = 'PeopleLanding',
	PersonalInfo = 'PersonalInfo',
	MaritalStatus = 'MaritalStatus',
	Dependents = 'Dependents',
	Demographics = 'Demographics',
	InstitutionAdministratorSearch = 'InstitutionAdministratorSearch',
	GroupAdminSearch = 'GroupAdminSearch',
	AddInstitutionAdministrator = 'AddInstitutionAdministrator',
	MidYear = 'MidYear',
	AECoverage = 'AECoverage',
    AEConfirmation = 'AEConfirmation',
	PensionEnrollment = 'PensionEnrollment',
	NonStipNewHire = 'NonStipNewHire',
	StipNewHire = 'StipNewHire',
	DocDownload = 'DocDownload',
	Termination = 'Termination',
	Reports = 'Reports',
	MyDocuments = 'MyDocuments',
	EmploymentHistory = 'EmploymentHistory',
}